const IOTypes = {
  Text: 'Text',
  Binary: 'Binary',
  Image: 'Image',
  Mesh: 'Mesh'
} as const

export default IOTypes
